import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PremiumDomainConnectSecondStep } from 'owa-domain-connect';

export async function launchDomainConnectSetAlias(
    domain: string,
    csrfToken: string
): Promise<void> {
    mountDomainConnectSecondStep(domain, csrfToken);
}

function mountDomainConnectSecondStep(domain: string, csrfToken: string) {
    var dcSecondStepContainer = document.createElement('div');
    document.body.appendChild(dcSecondStepContainer);
    ReactDOM.render(
        <PremiumDomainConnectSecondStep
            domainName={domain}
            csrfToken={csrfToken}
            mountFromDomainDashBoard={false}
            isSecondaryUser={false}
            onClose={() => document.body.removeChild(dcSecondStepContainer)}
        />,
        dcSecondStepContainer
    );
}
